import { ProviderEnum } from '@dynamic-labs/sdk-api';
import { DynamicError } from '@dynamic-labs/utils';
import '../../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../../../constants/colors.js';
import '../../../../../shared/utils/classes/storage/localStorage.js';
import 'viem';
import '../../../../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import { isProviderEnabled } from '../../../../functions/isProviderEnabled/isProviderEnabled.js';

const MissingMagicSetupError = new DynamicError('Magic is enabled but @dynamic-labs/magic package is not set up.\nSee https://docs.dynamic.xyz/docs/reduce-bundle-size-with-modular-sdk for more information');
const magicEmailOtpWalletConnectorKey = 'magicemailotp';
const magicSocialWalletConnectorKey = 'magicsocial';
const verifyMagicIsSetup = (projectSettings, walletConnectors) => {
    var _a;
    const isMagicEnabled = isProviderEnabled((_a = projectSettings.providers) !== null && _a !== void 0 ? _a : [], ProviderEnum.MagicLink);
    const isMagicWalletConnectorPresent = walletConnectors.some(({ key }) => [magicEmailOtpWalletConnectorKey, magicSocialWalletConnectorKey].includes(key));
    if (isMagicEnabled && !isMagicWalletConnectorPresent) {
        throw MissingMagicSetupError;
    }
};

export { MissingMagicSetupError, magicEmailOtpWalletConnectorKey, verifyMagicIsSetup };
